import React, { useState } from 'react'
import { Dropdown } from 'antd'

import type { MusicOption } from '../_types'
import type { ItemType } from 'antd/es/menu/interface'


import { useEffect } from 'react';
import { CssIcon } from '@/components/CssIcon';
import { cls } from 'tagged-classnames-free';
export interface OptionDropdownProps {
  items: MusicOption[]
  children?: React.ReactNode | ((open: boolean) => React.ReactNode)
  afterOpenChange?: (open: boolean) => void
}

const OptionDropdown: React.FC<OptionDropdownProps> = (props) => {
  const { items, afterOpenChange, children } = props

  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (afterOpenChange) {
      afterOpenChange(open)
    }
  }, [afterOpenChange, open])

  const renderItems: (_items: MusicOption[]) => ItemType[] = (_items) => {
    return _items.map((item) => {
      const result: ItemType = {
        key: item.key,
        className: 'group',
        label: (
          <span className='text-f-text-tertiary group-hover:text-f-primary-hover flex items-center gap-1 text-xs'>
            {typeof item.icon === 'string' ? (
              <CssIcon className={cls`size-4 ${item.icon}`} />
            ) : (
              item.icon
            )}
            <span>{item.label}</span>
          </span>
        ),
        onClick: (info) => {
          info.domEvent.stopPropagation()
          if ('onClick' in item) {
            item.onClick?.()
          }
        },
        children: item.children ? renderItems(item.children) : undefined,
      }
      return result
    })
  }

  return (
    <Dropdown
      placement='bottomRight'
      open={open}
      onOpenChange={(open) => {
        setOpen(open)
      }}
      menu={{
        items: renderItems(items),
        expandIcon: () => null,
      }}
    >
      {typeof children === 'function' ? children(open) : children}
    </Dropdown>
  )
}

export default OptionDropdown
